var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_1278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.86433 0.852089C6.83187 0.495035 6.63712 0.300279 6.28006 0.267819C5.92301 0.300279 5.72825 0.495035 5.69579 0.852089V7.42512L3.38306 5.11239C3.10715 4.88517 2.83125 4.88517 2.55534 5.11239C2.32813 5.38829 2.32813 5.6642 2.55534 5.9401L5.8662 9.25097C6.14211 9.47818 6.41801 9.47818 6.69392 9.25097L10.0048 5.9401C10.232 5.6642 10.232 5.38829 10.0048 5.11239C9.72888 4.88517 9.45297 4.88517 9.17706 5.11239L6.86433 7.42512V0.852089ZM3.1883 7.66857H1.6059C1.1677 7.6848 0.802533 7.83898 0.510398 8.13112C0.218264 8.42325 0.0640813 8.78842 0.0478516 9.22662V11.1742C0.0640813 11.6124 0.218264 11.9776 0.510398 12.2697C0.802533 12.5618 1.1677 12.716 1.6059 12.7322H10.9542C11.3924 12.716 11.7576 12.5618 12.0497 12.2697C12.3419 11.9776 12.496 11.6124 12.5123 11.1742V9.22662C12.496 8.78842 12.3419 8.42325 12.0497 8.13112C11.7576 7.83898 11.3924 7.6848 10.9542 7.66857H9.37182L8.20328 8.83711H10.9542C11.1977 8.85334 11.3275 8.98318 11.3437 9.22662V11.1742C11.3275 11.4176 11.1977 11.5475 10.9542 11.5637H1.6059C1.36246 11.5475 1.23262 11.4176 1.21639 11.1742V9.22662C1.23262 8.98318 1.36246 8.85334 1.6059 8.83711H4.35684L3.1883 7.66857ZM10.5647 10.2004C10.5322 9.84335 10.3375 9.64859 9.98044 9.61613C9.62338 9.64859 9.42863 9.84335 9.39617 10.2004C9.42863 10.5575 9.62338 10.7522 9.98044 10.7847C10.3375 10.7522 10.5322 10.5575 10.5647 10.2004Z",
    fill: "#6C757D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_1278"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.56,
    height: 13,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.25ef046f76b46bc49cd6a26f90914bd1.svg";
export { ForwardRef as ReactComponent };